import { render, staticRenderFns } from "./ProjectDetails.vue?vue&type=template&id=1cfd3c3b&scoped=true"
import script from "./ProjectDetails.vue?vue&type=script&lang=ts"
export * from "./ProjectDetails.vue?vue&type=script&lang=ts"
import style0 from "./ProjectDetails.vue?vue&type=style&index=0&id=1cfd3c3b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfd3c3b",
  null
  
)

export default component.exports